import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonColor } from 'src/app/shared/components/button/button.types';

@Component({
  selector: 'star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent {
  @Input()
  rating = 0;

  @Input()
  readonly = false;

  @Input()
  fullIcon = 'star';

  @Input()
  halfIcon = 'star-half';

  @Input()
  defaultIcon = 'star-outline';

  @Output()
  ratingEvent: EventEmitter<any> = new EventEmitter();

  @Input()
  color: ButtonColor = 'orange-500';

  roundedValue: any;

  /**
   * This function is used to set icon name.
   *
   * @param index - Get star index.
   */
  getIconName(index) {
    if (index <= this.getRoundedValue()) {
      return this.fullIcon;
    }
    if (this.rating > this.getRoundedValue() && index <= this.getRoundedValue() + 1) {
      return this.halfIcon;
    }
    return this.defaultIcon;
  }

  /**
   * This function is used to get rounded value.
   *
   */
  getRoundedValue() {
    return this.roundedValue || (this.roundedValue = Math.floor(this.rating));
  }

  /**
   * This function is used to change rating if readonly false.
   *
   * @param index - Get star index.
   */
  changeRating(index) {
    if (this.readonly) {
      return;
    }

    this.roundedValue = null;
    this.rating = index;

    if (this.ratingEvent) {
      this.ratingEvent.emit(index);
    }
  }
}
